'use client';

import { Segmented } from 'antd';
import { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';

import { If } from '@components/condition';
import { ConfirmModal } from '@components/shared';
import { modalActions } from '@store/actions';

import { ForgotPasswordForm } from './ForgotForm';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import classNames from 'classnames';

interface AuthModalProps {
  modalId: string;
}

export function AuthModal({ modalId }: AuthModalProps) {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState<string>('login');
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const handleForgotPassword = () => {
    setShowForgotPassword(true);
  };

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
    setActiveTab('login');
  };

  return (
    <ConfirmModal
      modalId={modalId}
      width={480}
      title={showForgotPassword ? 'Quên mật khẩu' : activeTab === 'login' ? 'Đăng nhập' : 'Đăng ký'}
    >
      {showForgotPassword ? (
        <ForgotPasswordForm onBack={handleBackToLogin} />
      ) : (
        <Fragment>
          <Segmented
            size="large"
            value={activeTab}
            onChange={setActiveTab}
            options={[
              {
                value: 'login',
                label: (
                  <div
                    className={classNames(activeTab === 'login' ? 'text-white' : 'text-orange-500')}
                  >
                    Đăng nhập
                  </div>
                ),
              },
              {
                value: 'register',
                label: (
                  <div
                    className={classNames(
                      activeTab === 'register' ? 'text-white' : 'text-orange-500'
                    )}
                  >
                    Đăng ký
                  </div>
                ),
              },
            ]}
            block
            className="!mb-4"
          />
          <If
            condition={activeTab === 'login'}
            Then={
              <LoginForm
                onForgotPassword={handleForgotPassword}
                onClose={() => dispatch(modalActions.closeModal({ modalId }))}
              />
            }
            Else={<RegisterForm onClose={() => dispatch(modalActions.closeModal({ modalId }))} />}
          />
        </Fragment>
      )}
    </ConfirmModal>
  );
}
